// extracted by mini-css-extract-plugin
export var cardContainer = "PageDataBodyHeadingWithIllustrations-module--cardContainer--MPUnN";
export var heading = "PageDataBodyHeadingWithIllustrations-module--heading--qrXYR";
export var innerContainer = "PageDataBodyHeadingWithIllustrations-module--innerContainer--W3IMs";